import React, { Component } from "react";
import {
  Switch,
  Route
} from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import configureStore from "./redux/store/configureStore";
import { history } from "./redux/store/configureStore";
import App from "./containers/app";
import ScrollTop from "./components/scrollToTop/ScrollToTop";
import PageNotFound from "./views/pageNotFound";
import Authorization from "./routes/Authorization";
import publicRoutes from "./routes/publicRoutes";
import affiliateRoutes from "./routes/affiliateRoutes";
import PublicLayout from "./layout/PublicLayout";
import AffiliateLayout from "./layout/AffiliateLayout";
import Maintenance from "./views/frontend/maintenance";
import {siteActions}    from './redux/actions/siteActions';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withRouter } from "react-router";
import isEmpty from "lodash.isempty";
import "./InitialSetup.css"
import HttpsRedirect from 'react-https-redirect';

import Cookies from "universal-cookie";
const cookies = new Cookies();

let sitestatus="", siteprotocol="";
class InitialSetup extends Component {

  componentWillMount(){
    if(isEmpty(this.props.siteStatus) || (typeof this.props.siteStatus != 'undefined')){
      const { actions: { checkSiteStatus } } = this.props;
      checkSiteStatus();
    }
  }

  componentWillReceiveProps(nextProps){
    if(this.props.siteStatus !== nextProps.siteStatus){
      if(nextProps.siteStatus){
        if(typeof cookies.get("cityID") != 'undefined'){
          let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
          siteData.default_city = cookies.get("cityID");
          localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
          siteprotocol=nextProps.siteStatus.siteDomain.split(":");
          sitestatus=nextProps.siteStatus.status;
        }else{
          siteprotocol=nextProps.siteStatus.siteDomain.split(":");
          sitestatus=nextProps.siteStatus.status;
        }
      }
    }
  }
    
  
  render() {
    const user = {};
    if(sitestatus=="Inactive"){
      return ( <Maintenance/> );
    }else if(sitestatus=="Active"){
      return (
          <React.Fragment>
          {(siteprotocol[0] == 'http') ?
          <div className="main-container" >
            <ConnectedRouter history={history}>
              <ScrollTop>
                <Switch>
                  {_.map(publicRoutes, (route, key) => {
                    const { component, path } = route;
                    return (
                      <Route
                        exact
                        path={path}
                        key={key}
                        render={route => (
                          <PublicLayout
                            component={component}
                            route={route}
                            user={user}
                          />
                        )}
                      />
                    );
                  })}
                  {_.map(affiliateRoutes, (route, key) => {
                    const { component, path } = route;
                    return (
                      <Route
                        exact
                        path={path}
                        key={key}
                        render={route => (
                          <AffiliateLayout
                            component={component}
                            route={route}
                            user={user}
                          />
                        )}
                      />
                    );
                  })}
                  <App />
                  <Route component={PageNotFound} />
                </Switch>
                
              </ScrollTop>
            </ConnectedRouter>
            
          </div>
          :
          <HttpsRedirect>
          <div className="main-container" >
            <ConnectedRouter history={history}>
              <ScrollTop>
                <Switch>
                  {_.map(publicRoutes, (route, key) => {
                    const { component, path } = route;
                    return (
                      <Route
                        exact
                        path={path}
                        key={key}
                        render={route => (
                          <PublicLayout
                            component={component}
                            route={route}
                            user={user}
                          />
                        )}
                      />
                    );
                  })}
                  {_.map(affiliateRoutes, (route, key) => {
                    const { component, path } = route;
                    return (
                      <Route
                        exact
                        path={path}
                        key={key}
                        render={route => (
                          <AffiliateLayout
                            component={component}
                            route={route}
                            user={user}
                          />
                        )}
                      />
                    );
                  })}
                  <App />
                  <Route component={PageNotFound} />
                </Switch>
                
              </ScrollTop>
            </ConnectedRouter>
            
          </div>
          </HttpsRedirect>
          }
          </React.Fragment>
      );
    }else{
      return (
        <div>
        </div>
      );
    }
  }
}
  
const mapStateToProps = (state) => {
  return {
    error:  state.designCenterReducer.error,
    siteStatus:  state.siteReducer.siteStatus
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        ...siteActions
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InitialSetup);



// WEBPACK FOOTER //
// ./src/app/InitialSetup.js